//import { combineReducers } from 'redux';
import { createReducer, getType } from 'typesafe-actions';

import { userLoggedIn, userLoginFail, userXsrfToken, tenantAction, initializeAuthActions } from '../actions/auth.actions';
import { authInit } from '../dtos/auth';

const authReducer = createReducer(authInit)
  .handleType(getType(userLoggedIn), (state, action) => ({
    ...action.payload,
    // Ensure status is set when user logs in (should be 'authenticated')
    status: action.payload.status || (action.payload.isAuthenticated ? 'authenticated' : 'anonymous'),
  }))
  .handleType(getType(userLoginFail), (state, action) => ({
    ...action.payload,
    status: 'anonymous',  // Login failed, user is anonymous
  }))
  .handleType(getType(initializeAuthActions.success), (state) => ({
    ...state,
    status: 'authenticated',  // Auth hydration succeeded
  }))
  .handleType(getType(initializeAuthActions.failure), (state) => ({
    ...state,
    status: 'anonymous',  // Auth hydration failed, user is anonymous
    isAuthenticated: false,
    roles: [],
  }));

export default authReducer;

export const token = createReducer('')
  .handleType(getType(userXsrfToken), (state, action) => action.payload);

export const tenant = createReducer('oha')
  .handleType(getType(tenantAction), (state, action) => action.payload);